// extracted by mini-css-extract-plugin
module.exports = {"button":"button-1VbVB","button_small":"button_small-KEOPC"};